import * as React from "react";
import { func } from "prop-types";
import * as styles from "./styles.scss";
import { extractCourseId } from "../../utils";

export class Audio extends React.Component<{
  src: string;
  duration?: number;
}> {
  audio: any = null;

  componentDidMount() {
    (window as any).AT.initPlayer(this.audio);
  }

  render() {
    return (
      <div className={styles.preloader}>
        <audio
          controls={true}
          preload="metadata"
          className="js-player"
          ref={(node) => (this.audio = node)}
        >
          <source src={this.props.src} />
          Ваш браузер не поддерживает проигрывание аудио в таком формате.
          Попробуйте восползоваться Google Chrome.
        </audio>
      </div>
    );
  }
}
